module.exports = __webpack_public_path__ + "img/sbar.31bb5c67.png";